import React from 'react';
import ReactDOM  from 'react-dom'
import {Route, Redirect } from 'react-router-dom'


class PublicRoute extends React.Component {


    constructor(props) {
	super(props);

    }

    render() {

	const {component, authenticated} = this.props

	const Component = component
	if(authenticated === undefined)
	    return (<div></div>)
	else{
	    return (
		<Route render={props => !authenticated  ? <Component {...this.props} /> : <Redirect to={{pathname: "/", state: { from: this.props.location }  }} />} />
	    )
	}
	    

    }
}

export default PublicRoute;



// WEBPACK FOOTER //
// ./src/utils/PublicRoute/PublicRoute.jsx